import classNames from 'classnames'

import { StepProps } from './Step.schema'

import Button from '@/button/Button'
import Markdown from '@/markdown/Markdown'
import Appear from '@/appear/Appear'

const StepWrapper = (props: StepProps): JSX.Element => {
    const className = classNames(
        'step',
        props.className,
        props.gapSize && ('step--' + props.gapSize + '-gap')
    )

    if (props.disableAppear) {
        return (
            <div className={className}>
                {props.children}
            </div>
        )
    }

    return (
        <div className={className}>
            <Appear cascade delay={props.appearDelay}>
                {props.children}
            </Appear>
            {props.backgroundImage && (
                props.backgroundImage
            )}
        </div>
    )
}

const Step = (props: StepProps): JSX.Element => {
    const HeadingElement = props.headingElement ?? 'h1'
    const headingDisplay = props.headingDisplay ?? 'h3'

    const headingClassName = classNames('step__title', headingDisplay + '--display')
    const descriptionClassName = classNames('step__description text', props.textSize && ('text-' + props.textSize))

    return (
        <StepWrapper {...props}>
            {props.title && (
                <HeadingElement
                    className={headingClassName}
                    dangerouslySetInnerHTML={{ __html: props.title.replace(/<(?!mark|\/mark)[^>]+>/ig, '') }}
                />
            )}
            {props.description && (
                <Markdown className={descriptionClassName} useChecklist={props.useChecklist}>{props.description}</Markdown>
            )}
            <div className='step__children'>
                {props.children}
            </div>
            {props.button && (
                <Button className='step__button' icon='arrow-right' iconPosition='right' color='yellow' size='large' {...props.button} />
            )}
        </StepWrapper>
    )
}

export default Step